<template>

      <sequential-entrance fromBottom>
    <v-card-text class="pt-0">
              <div class="spacer" />
<v-row>
  <v-col>
      <div class="headline font-weight-light mb-2" style="color:#fff; text-align:left;">Grade</div>
  </v-col>
  <v-col>
      <div class="title font-weight-light mb-2" style="color:#ffffff; text-align:right;">66%</div>

  </v-col>
</v-row>
      <v-divider class="my-2"></v-divider>
              <div class="spacer" />
              <div class="spacer" />
         <div class="display-4 font-weight-bold mb-2" style="color:#fff; text-align:center;">F</div>
              <div class="spacer" />
    </v-card-text>

  </sequential-entrance>

</template>



<script>
export default {
  name: "Accounting Grade",
  data() {
    return {
      date: new Date().toDateString(),
    };
  },
  methods: {
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      // this.alert = "true";
      },
      getEvents() {
        window.gapi.client.calendar.events
          .list({
            calendarId: "primary",
            timeMin: new Date(2019, 1, 1).toISOString(),
            timeMax: new Date().toISOString(),
            showDeleted: false,
            singleEvents: true,
            maxResults: 10,
            orderBy: "startTime",
          })
          .then((response) => {
            this.items = response.result.items;
            console.log(this.items);
          });
      },

      countDown(time, update, complete) {
        var start = new Date().getTime();
        var interval = setInterval(function () {
          var now = time - (new Date().getTime() - start);
          if (now <= 0) {
            clearInterval(interval);
            complete();
          } else update(Math.floor(now / 1000));
        }, 100); // the smaller this number, the more accurate the timer will be
      },
      convertTime(sec, delayed) {
        var hours = Math.floor(sec / 3600);
        hours >= 1 ? (sec = sec - hours * 3600) : (hours = "00");
        var min = Math.floor(sec / 60);
        min >= 1 ? (sec = sec - min * 60) : (min = "00");
        sec < 1 ? (sec = "00") : void 0;
        min.toString().length == 1 ? (min = "0" + min) : void 0;
        sec.toString().length == 1 ? (sec = "0" + sec) : void 0;
        document.getElementById("timer").innerHTML =
          `<span style="color:${delayed == "delayed" ? "red;" : "#44da91;"}">` +
          hours +
          ":" +
          min +
          ":" +
          sec +
          " <strong >" +
          delayed +
          " <strong> </span>";
      },
    },

  mounted() {
    // console.log(google.client.gmail)
    if (!localStorage.currentUser) {
      this.readOutLoud(`Please Confirm you authentication first`);
      this.$router.push({ name: "login" });
    }
    this.userInfo = JSON.parse(localStorage.getItem("currentUser"));

    let self = this;
    this.countDown(
      5000, // milliseconds
      (timeleft) => {
        self.convertTime(timeleft, "remaining"); // If time is remaining
      },
      () => {
        self.readOutLoud(`Your accounting department grade is currently a F,..... and your total collected year to date is $345,425.18. We should go over the details and initiate a strategy to correct future trajectories, is this a good time?`);
        let i = 0;
        setInterval(() => {
          i = ++i;
          self.convertTime(i, "delayed"); // Time is delayed
        }, 1000);
      },
      2000
    );
  },
};
</script>

<style scoped>

.spacer{
  height:32px;
  }

.card{
  height:260px;
  }

</style>
